export const WRONG_AUTHORIZATION_TOKEN = 'WRONG_AUTHORIZATION_TOKEN';
export const COMPILATION_LIMIT_EXCEEDED = 'COMPILATION_LIMIT_EXCEEDED';
export const COMPILATION_SERVICE_ERROR = 'COMPILATION_SERVICE_ERROR';
export const WASM_UNKNOWN_COMPILATION_ERROR = 'WASM_UNKNOWN_COMPILATION_ERROR';
export const WASM_COMPILATION_RESULTS_FETCH_ERROR =
  'WASM_COMPILATION_RESULTS_FETCH_ERROR';
export const WASM_COMPILATION_ERROR = 'WASM_COMPILATION_ERROR';
export const WASM_EXECUTION_ABORT = 'WASM_EXECUTION_ABORT';
export const WASM_NONZERO_EXIT_CODE = 'WASM_NONZERO_EXIT_CODE';

export const WASM_NO_RUNTIME_FOUND = 'WASM_NO_RUNTIME_FOUND';
export const WASM_BINARY_NOT_FOUND = 'WASM_BINARY_NOT_FOUND';



// WEBPACK FOOTER //
// ../src/errorCodes.js